import { KROT } from 'captcha-eu-sdk';

const captcha = () => {
  KROT.init();
  KROT.KROT_HOST = 'https://w19.captcha.at';
  KROT.setup(document.body.dataset.captchaPublicKey);

  // Create account
  var checkbox_create_account = document.querySelector(
    '.cart_create_account input[type="checkbox"]'
  );
  if (checkbox_create_account) {
    $('.password-wrapper').hide();
    if (checkbox_create_account.checked) {
      $('.password-wrapper').show();
      KROT.interceptForm(checkbox_create_account.closest('form'));
    }
    checkbox_create_account.addEventListener('change', (e) => {
      if (e.target.checked) {
        $('.password-wrapper').show();
        KROT.interceptForm(e.target.closest('form'));
      } else {
        $('.password-wrapper').hide();
      }
    });
  }

  document.querySelectorAll('form.validate-captcha').forEach((form) => {
    if (form.dataset.krotBinded) return;
    // This is not working well with Turbo
    // KROT.interceptForm(form);

    form.addEventListener('submit', (e) => {
      let input = e.target.querySelector('input.captcha-at-solution');
      if (!input) {
        e.preventDefault();

        KROT.getSolution().then((solution) => {
          input = document.createElement('input')
          input.name = 'captcha_at_solution'
          input.type = 'hidden'
          input.value = JSON.stringify(solution)
          e.target.appendChild(input)
          e.target.submit()
        });
      }
    });

    form.dataset.krotBinded = true;
  });
};

export default captcha;